import { graphql } from '../../gql';

export const PAY_V3_QUERY = graphql(`
  query GetPayV3($req: PayV3Req) {
    pay_v3(req: $req) {
      entities {
        id
        short_name
        long_name
        metrics {
          overtime {
            counts
            salary_base
            salary_total
            salary_hourly
          }
          histogram {
            id
            short_name
            long_name
            base
            total
            hourly
          }
          top_companies {
            id
            short_name
            long_name
            base
            total
            hourly
          }
          top_geos {
            id
            short_name
            long_name
            base
            total
            hourly
          }
          top_roles {
            id
            short_name
            long_name
            base
            total
            hourly
          }
        }
      }
      refs {
        months
      }
    }
  }
`);

export const PAY_V3_TOOLTIP_QUERY = graphql(`
  query GetPayV3Tooltip($req: PayV3Req) {
    pay_v3(req: $req) {
      entities {
        id
        short_name
        long_name
        metrics {
          histogram {
            id
            short_name
            long_name
            base
            total
            hourly
          }
        }
      }
      refs {
        months
      }
    }
  }
`);

export const PAY_V3_TOPGEOS_QUERY = graphql(`
  query GetPayV3TopGeos($req: PayV3Req) {
    pay_v3(req: $req) {
      entities {
        id
        short_name
        long_name
        metrics {
          top_geos {
            id
            short_name
            long_name
            base
            total
            hourly
          }
        }
      }
      refs {
        months
      }
    }
  }
`);

// Assistant reads select only the figures or ranking candidates they consume.
export const PAY_FIGURES_QUERY = graphql(`
  query PayFigures($req: PayV3Req) {
    pay_v3(req: $req) {
      entities {
        id
        short_name
        long_name
        metrics {
          overtime {
            counts
            salary_base
            salary_total
            salary_hourly
          }
        }
      }
      refs {
        months
      }
    }
  }
`);

export const PAY_TOP_COMPANIES_QUERY = graphql(`
  query PayTopCompanies($req: PayV3Req) {
    pay_v3(req: $req) {
      entities {
        id
        short_name
        long_name
        metrics {
          top_companies {
            id
            short_name
            long_name
            base
            total
            hourly
          }
        }
      }
    }
  }
`);
